module.exports = __webpack_public_path__ + "img/4.fb908ed7.jpg";